<!--
================================================
Un composant affichant une modale contenant les
conditions d'utilisation.


⚠️ EN CAS DE MISE À JOUR DES TERMS :
 * Maj des terms  /Users/ousmanendiaye/PhpstormProjects/cronocloud-web-nuxt/pages/legal/terms.vue
 *  REPORTER DANS LA TABLES TERMS DU BACKEND (CAR LES TERMS SONT AUSSI AFFICHÉES DANS LA PAGE SIGNUP DE LA PWA)
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div>
        <div class="modal" id="modalTerms" v-bind:class="{ 'is-active': isVisible }">

            <!--ajouter la classe is-active sur.modal pour afficher-->
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{$t('ConditionsDUtilisation')}}</p>
                    <button v-on:click="toggleVisibility()" id="closeModalTerms" class="delete" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    <!-- Content ... -->
                    <div class="spinnerContainer" v-show="isLoading">
                        <spinner-loader-comp></spinner-loader-comp>
                    </div>

                    <span v-html="termsContent" class="content"></span>

                    <div class="lastUpdate">{{$t('derniereMiseAJourLeX',{lastUpdate:$moment(termsLastUpdate).format('LL')})}}</div>

                </section>
                <footer class="modal-card-foot">
                </footer>

            </div>

        </div>
    </div>
</template>



<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";


    export default {
        name: 'ModalComp',
        components: {
            SpinnerLoaderComp,
        },
        mixins: [GlobalErrorNotification, TrackingMixin],
        data: function () {
            return {
                termsContent:'',    // le contenu des terms
                termsLastUpdate:'',    // la date de maj des terms
                isLoading: true,  // visibilité du loader .spinner
            }
        },
        computed: mapState({
            isVisible: state => state.ModalTermslComp.isVisible,
        }),

        methods: {

            /*
            Toggle l'affichage de la modal
           */
            toggleVisibility() {
                if (this.isVisible === true) {this.hide()}
                else {this.show()}
            },

            /*
            Affiche la modal
             */
            show() {
                this.$store.commit('UpdateModalTermsComp', {'isVisible':true})
                this.ga4GlobalEventTrack('Terms modal displayed' , {})

            },

            /*
            Masque la modal
             */
            hide() {
                this.$store.commit('UpdateModalTermsComp', {'isVisible':false})
            },

            /*
            Effectue une requête pour récupérer les terms
            */
            getTerms() {
                let self =this;
                self.isLoading = true;
                return self.$http
                    .get("/public/terms/"+self.$route.params.locale)
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                        self.termsContent = response.data.content
                        self.termsLastUpdate = response.data.updatedAt
                        self.isLoading = false;
                        return {
                        }
                    })
                    .catch(function (error) {
                        let errorCode = '0042'
                        self.showGlobalErrorNotif(self,errorCode)
                        self.$gtag.exception({'description': 'error '+errorCode + ' | error on fetching terms on modal', 'fatal': false})

                        self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error on fetching terms on modalTerms"})
                        self.$sentry.captureMessage(`Error ${errorCode} > fetching terms on modalTerms : ${error}`, 'error')


                    })
            }

        },

        mounted: function () {
            // récupération des terms
            this.getTerms();

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";

    .modal{
        .modal-card-title{}

        .spinner{
            img{
                padding: 0;
            display: block;
            margin:  auto;
            }
        }

      .lastUpdate{
        font-size: 0.9rem; margin: 1rem auto 0; font-style: italic; color: $brandThird;
        text-align: right;
      }
    }

</style>
